import axiosConfig from "./axiosConfig";

// Helper function to handle file downloads
export const downloadFile = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};


// Generic export function
export const exportData = async (endpoint, filename, queryParams) => {
    try {
        const response = await axiosConfig.get(endpoint, {
            responseType: 'blob',
            params: queryParams
        });

        // Detect file type from response headers
        const contentType = response.data?.type
        let extension = '';
        if (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
            extension = '.xlsx';
        } else if (contentType.includes('text/csv') || contentType.includes('application/csv')) {
            extension = '.csv';
        }

        const now = new Date();
        const formattedDate = now.getFullYear().toString() +
            String(now.getMonth() + 1).padStart(2, '0') +
            String(now.getDate()).padStart(2, '0') + '_' +
            String(now.getHours()).padStart(2, '0') +
            String(now.getMinutes()).padStart(2, '0') +
            String(now.getSeconds()).padStart(2, '0');
        downloadFile(new Blob([response.data]), `${filename}_${formattedDate}${extension}`);
        return response;
    } catch (error) {
        throw error;
    }
};
